<div class="cx-image-zoom-dialog" [cxFocus]="focusConfig">
  <div class="cx-dialog-content ui-mob-height">
    <div class="cx-dialog-header">
      <button
        type="button"
        class="close"
        [attr.aria-label]="'productImageZoomDialog.close' | cxTranslate"
        (click)="close('cross click')"
      >
        <span aria-hidden="true">
          <cx-icon [type]="iconType.CLOSE"></cx-icon>
        </span>
      </button>
    </div>
    <div class="cx-dialog-body">
      <div id="view360"></div>
    </div>
  </div>
</div>
